<div >
    <h4 *ngIf="numberOS!==null">OS {{data.numberOS}}</h4>
    <input style="display: none" type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,image/jpeg,image/png" multiple (change)="onFileSelected($event)" #fileUpload>
  
    <div style="display: flex;justify-content: center">
  
      <button mat-raised-button class="buttonPrimary" style="width: 35rem" (click)="fileUpload.click()">
        Cargar archivos
      </button>
  
    </div>
  </div>
  
  
  <div *ngIf="loadingService.isLoading | async" class="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
  
  <div style="display: flex;flex-wrap: wrap;gap: 10px;margin-bottom: 20px;padding-top: 20px">
  
    <div style="width: 100%;display: flex;justify-content: center;gap: 10px" *ngFor="let multimedia of multimedia; let i=index">
  
      <div style="background-color: white;width: 40rem;border: solid;border-color: rgba(0,0,0,.12);border-width: 1px;border-radius: 10px;
            align-items: center;padding: 12px" >
  
        <div style="display: flex;justify-content: space-between;align-items: center">
  
  
        <div> {{multimedia.name}}</div>
  
        <div style="display: flex;justify-content: center;gap: 10px">
          <button mat-icon-button (click)="deleteMultimedia(multimedia,i)">
            <mat-icon class="icon-color">delete</mat-icon>
          </button>
          <button mat-icon-button (click)="activatePDF(multimedia,i)">
  <!--          <mat-icon class="icon-color">picture_as_pdf</mat-icon>-->
            <mat-icon class="icon-color">photo</mat-icon>
          </button>
          <button mat-icon-button (click)="downloadFile(multimedia)"  >
            <mat-icon class="icon-color" >download</mat-icon>
          </button>
        </div>
  
        </div>
  
        <div style="display: flex;justify-content: center" *ngIf="pdfViewer && index==i">
          <iframe [src]="url" width="600" height="400">
          </iframe>
        </div>
  
      </div>
    </div>
  
  </div>
  